import { csv, csvParse } from "d3";
import { isArray, isString, isNumber } from "lodash";
import axios from "axios";

class Data {

	constructor () {
		this.songs = {};
		this.artists = {};
		this.pays = require("../utils/countries.json");
		this.languages = require("../utils/languages.json");
		/* Requête SPARQL
		PREFIX banq: <http://example.org/>
		PREFIX rdaa: <http://rdaregistry.info/Elements/a/>
		PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
		SELECT distinct ?id ?country_activity ?country_birth ?role ?birth_year ?name ?label WHERE {
			OPTIONAL { ?id banq:hasActivityCountry ?country_activity . }
			OPTIONAL { ?id banq:hasBirthCountry ?country_birth . }
			OPTIONAL { ?id rdaa:P50121 ?birth_year . }
			OPTIONAL { ?performed_song banq:hasPerformer ?id . } 
			?id banq:hasName ?name .
			?id rdfs:label ?label .
			BIND("autority" as ?data_type) .
			BIND(IF(BOUND(?performed_song),"Interprète","Auteur") as ?role)
		} 
		*/

		this.artist_query = "https://data.banq.qc.ca/repositories/frerejacques?name=artist+query&infer=true&sameAs=true&query=PREFIX+banq%3A+%3Chttp%3A%2F%2Fexample.org%2F%3E%0APREFIX+rdaa%3A+%3Chttp%3A%2F%2Frdaregistry.info%2FElements%2Fa%2F%3E%0APREFIX+rdfs%3A+%3Chttp%3A%2F%2Fwww.w3.org%2F2000%2F01%2Frdf-schema%23%3E%0ASELECT+distinct+%3Fid+%3Fcountry_activity+%3Fcountry_birth+%3Frole+%3Fbirth_year+%3Fname+%3Flabel+WHERE+%7B%0A++++OPTIONAL+%7B+%3Fid+banq%3AhasActivityCountry+%3Fcountry_activity+.+%7D%0A++++OPTIONAL+%7B+%3Fid+banq%3AhasBirthCountry+%3Fcountry_birth+.+%7D%0A++++OPTIONAL+%7B+%3Fid+rdaa%3AP50121+%3Fbirth_year+.+%7D%0A++++OPTIONAL+%7B+%3Fperformed_song+banq%3AhasPerformer+%3Fid+.+%7D+%0A++++%3Fid+banq%3AhasName+%3Fname+.%0A++++%3Fid+rdfs%3Alabel+%3Flabel+.%0A++++BIND(%22autority%22+as+%3Fdata_type)+.%0A++++BIND(IF(BOUND(%3Fperformed_song)%2C%22Interpr%C3%A8te%22%2C%22Auteur%22)+as+%3Frole)%0A%7D+";
		/* 
		PREFIX rdau: <http://rdaregistry.info/Elements/u/> 
		PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> 
		PREFIX banq: <http://example.org/> 
		SELECT distinct ?id ?data_type ?note ?title ?label ?language ?parent_id ?has_parent ?country_origin ?year (CONCAT(?composer_ids, ";", ?author_ids, ";", ?interpret_ids) as ?artist_ids)  (group_concat(distinct (?author); separator=";") as ?author_ids)  (group_concat(distinct (?performer); separator=";") as ?interpret_ids)  (group_concat(distinct (?composer); separator=";") as ?composer_ids) ?primary_performer WHERE { 
			?id rdau:P60369 ?title . 
			?id rdfs:label ?label . 
			OPTIONAL { ?id rdau:P60099 ?language . }
			OPTIONAL { ?id banq:parentID ?parent_id . } 
    		OPTIONAL { ?id rdau:P60056 ?note . } 
			OPTIONAL { ?id rdau:P60073 ?year . } 
			OPTIONAL { ?id rdau:P60523 ?country_origin } . 
			OPTIONAL { ?id banq:hasAuthor ?author . } 
    		OPTIONAL { ?id banq:hasComposer ?composer . } 
    		OPTIONAL { ?id banq:hasPerformer ?performer . } 
    		OPTIONAL { ?id banq:hasPrimaryPerformer ?primary_performer . } 
			BIND(BOUND(?parent_id) as ?has_parent) . 
    		BIND("song" as ?data_type) . 
		 
		} GROUP BY ?id ?data_type ?note ?title ?label ?language ?parent_id ?has_parent ?country_origin ?year ?data_type ?primary_performer 
		*/ 
		this.song_query = "https://data.banq.qc.ca/repositories/frerejacques?name=&infer=true&sameAs=true&query=PREFIX+rdau%3A+%3Chttp%3A%2F%2Frdaregistry.info%2FElements%2Fu%2F%3E+%0D%0A%09%09PREFIX+rdfs%3A+%3Chttp%3A%2F%2Fwww.w3.org%2F2000%2F01%2Frdf-schema%23%3E+%0D%0A%09%09PREFIX+banq%3A+%3Chttp%3A%2F%2Fexample.org%2F%3E+%0D%0A%09%09SELECT+distinct+%3Fid+%3Fdata_type+%3Fnote+%3Ftitle+%3Flabel+%3Flanguage+%3Fparent_id+%3Fhas_parent+%3Fcountry_origin+%3Fyear+%28CONCAT%28%3Fcomposer_ids%2C+%22%3B%22%2C+%3Fauthor_ids%2C+%22%3B%22%2C+%3Finterpret_ids%29+as+%3Fartist_ids%29++%28group_concat%28distinct+%28%3Fauthor%29%3B+separator%3D%22%3B%22%29+as+%3Fauthor_ids%29++%28group_concat%28distinct+%28%3Fperformer%29%3B+separator%3D%22%3B%22%29+as+%3Finterpret_ids%29++%28group_concat%28distinct+%28%3Fcomposer%29%3B+separator%3D%22%3B%22%29+as+%3Fcomposer_ids%29+%3Fprimary_performer+WHERE+%7B+%0D%0A%09%09%09%3Fid+rdau%3AP60369+%3Ftitle+.+%0D%0A%09%09%09%3Fid+rdfs%3Alabel+%3Flabel+.+%0D%0A%09%09%09OPTIONAL+%7B+%3Fid+rdau%3AP60099+%3Flanguage+.+%7D%0D%0A%09%09%09OPTIONAL+%7B+%3Fid+banq%3AparentID+%3Fparent_id+.+%7D+%0D%0A++++%09%09OPTIONAL+%7B+%3Fid+rdau%3AP60056+%3Fnote+.+%7D+%0D%0A%09%09%09OPTIONAL+%7B+%3Fid+rdau%3AP60073+%3Fyear+.+%7D+%0D%0A%09%09%09OPTIONAL+%7B+%3Fid+rdau%3AP60523+%3Fcountry_origin+%7D+.+%0D%0A%09%09%09OPTIONAL+%7B+%3Fid+banq%3AhasAuthor+%3Fauthor+.+%7D+%0D%0A++++%09%09OPTIONAL+%7B+%3Fid+banq%3AhasComposer+%3Fcomposer+.+%7D+%0D%0A++++%09%09OPTIONAL+%7B+%3Fid+banq%3AhasPerformer+%3Fperformer+.+%7D+%0D%0A++++%09%09OPTIONAL+%7B+%3Fid+banq%3AhasPrimaryPerformer+%3Fprimary_performer+.+%7D+%0D%0A%09%09%09BIND%28BOUND%28%3Fparent_id%29+as+%3Fhas_parent%29+.+%0D%0A++++%09%09BIND%28%22song%22+as+%3Fdata_type%29+.+%0D%0A%09%09+%0D%0A%09%09%7D+GROUP+BY+%3Fid+%3Fdata_type+%3Fnote+%3Ftitle+%3Flabel+%3Flanguage+%3Fparent_id+%3Fhas_parent+%3Fcountry_origin+%3Fyear+%3Fdata_type+%3Fprimary_performer"; 
	}

	async fetchData () {

		await csv("/data/songs.csv", (data) => {
			this.songs[data.id] = this.fromCSV(data);
		});
		await csv("/data/artists.csv", (data) => {
			this.artists[data.id] = this.fromCSV(data);
		});
    
		return {
			songs: this.songs,
			artists: this.artists
		};
	}
  
	async fetchDataRemote () {

		/**
     * Artist data
     */

		let artist_data = await axios.get(this.artist_query, {
			transformResponse: undefined,
			headers: {"Accept": "text/csv"}
		});
    
		artist_data = artist_data.data
			.replace(new RegExp("http://example.org/([a-c][0]+)", "g"), "")
			.replace(new RegExp("http://example.org/([a-c])", "g"), "");

		// Countries

		for (var key in this.pays) {
			artist_data = artist_data.replace(new RegExp(key, "g"), this.pays[key]);
		}	
    
		csvParse(artist_data, (csv_data) => {
			csv_data["data_type"] = "autority";
			this.artists[csv_data.id] = this.fromCSV(csv_data);
      
			// Some names contains dates
			this.artists[csv_data.id]["label"] = this.artists[csv_data.id]["label"].replace(/^(\d{4}\-(\d{4})? )/gm, "");
			this.artists[csv_data.id]["name"] = this.artists[csv_data.id]["label"];
		});

		/**
     * Song data
     */
    		
		let song_data = await axios.get(this.song_query, {
			transformResponse: undefined,
			headers: {"Accept": "text/csv"}
		});

		song_data = song_data.data
			.replace(new RegExp("http://example.org/([a-c][0]+)", "g"), "")
			.replace(new RegExp("http://example.org/([a-c])", "g"), "")
			.replace(new RegExp("dbp:", "g"), "");
    
		// Countries

		for (var key in this.pays) {
			song_data = song_data.replace(new RegExp(key, "g"), this.pays[key]);
		}
    
		// Languages
    
		for (var key in this.languages) {
			song_data = song_data.replace(new RegExp(key, "g"), this.languages[key]);
		}
    
		song_data = song_data
			.replace(new RegExp("http://dbpedia.org/page/", "g"), "")
			.replace(new RegExp("_languages", "g"), "")
			.replace(new RegExp("_language", "g"), "");
      		
		csvParse(song_data, (csv_data) => {
			let song = this.fromCSV(csv_data);
			song["data_type"] = "song";
			song["artist_id"] = song.artist_ids[0];
			song["composer_id"] = song.composer_ids[0];
			song["interpret_id"] = song.interpret_ids[0];
			song["author_id"] = song.author_ids[0];
			song["country_origin"] = this.mode(song.artist_ids.map(id => {
				return this.artists[id].country_activity;
			}));
      
			// TODO: Fix the banq server: All songs are duplicated with another ID
			if (!song["id"].includes("https://data.banq.qc.ca")) {
				this.songs[song.id] = song;
			}
		});
            
		this.findNumberOfChildren();

		this.findMainInterprets();
    
		this.findRootIds();
    
		// To Export CSV
		/* console.log(this.toCSV(Object.values(this.artists)));
		console.log(this.toCSV(Object.values(this.songs))); */
        
		return {
			songs: this.songs,
			artists: this.artists
		};
	}
  
	toCSV (data) {
		let keys = Object.keys(data[0]);
		let csv = keys.join(",");
		data.forEach(d => {
			csv += "\r\n";
			keys.forEach((key, i) => {  
                          
				if (isArray(d[key])) {
					csv += `"${d[key].join(";")}"`;
				} else if (isString(d[key]) ) {
					let result = d[key].replace(/"/g, "\"\"");
					csv += `"${result}"`;
				} else if (isNumber(d[key])) {
					csv += `${d[key]}`;
				} else {
					csv += `"${d[key]}"`;
				}

				if (i < keys.length - 1) {
					csv += ",";
				}
			});
		});
		return csv;
	}

	fromCSV (data) {
		let arrayKeys = ["artist_ids", "author_ids", "interpret_ids", "composer_ids", "cover_ids", "original_artist_ids"];
		let numberKeys = ["n_children"];
		Object.keys(data).forEach(key => {
			if (arrayKeys.includes(key)) {
				data[key] = data[key] == "" ? [] : data[key].split(";").filter(id => id != "");
			} else if (numberKeys.includes(key)) {
				data[key] = data[key] == "" ? "" : parseInt(data[key]);
			}
		});
		return data;
	}
  
	findNumberOfChildren () {

		Object.keys(this.songs).forEach(id => {
			this.songs[id].n_children = 0;
		});
    
		Object.keys(this.songs).forEach(id => {      
			if (this.songs[id].parent_id && this.songs[this.songs[id].parent_id] !== undefined) {
				this.songs[this.songs[id].parent_id].n_children++;
			}
		});
	}
  
	findRootIds () {
		Object.keys(this.songs).forEach(id => {
			if (this.songs[id].root_id !== undefined) {
				return;
			}
			if (this.songs[id].parent_id != "") {
				let parent = this.songs[this.songs[id].parent_id];
				if (parent.root_id !== undefined) {
					this.songs[id].root_id = parent.root_id;
					return;
				}
			}
      
			let root = this.findRootSong(this.songs[id]);
			this.songs[id].root_id = root.id;
		});
	}

	findRootSong (song) {
		let found = false;
		while (!found) {
			if (song.parent_id == "") {
				found = true;
				return song;
			}
			song = this.songs[song.parent_id];
		}
		return null;
	}
  
	findMainInterprets () {
		Object.keys(this.songs).forEach(id => {
			let primaryPerformer = this.songs[id].primary_performer;
			if (primaryPerformer === undefined || primaryPerformer === null || primaryPerformer == "" || this.artists[primaryPerformer] === undefined) {
				primaryPerformer = this.songs[id].interpret_id;
			}
			let coverIds = this.songs[id].interpret_ids.filter(id => id !== primaryPerformer);
			if (primaryPerformer) {
				this.songs[id].interpret_id = primaryPerformer;
				this.songs[id].interpret_ids = [primaryPerformer];
			} else {
				this.songs[id].interpret_id = undefined;
				this.songs[id].interpret_ids = [];
			}
			this.songs[id].cover_ids = coverIds;
			this.songs[id].original_artist_ids = [];
			this.songs[id].original_artist_ids = this.songs[id].interpret_ids.concat(this.songs[id].composer_ids, this.songs[id].author_ids);
		});
	}
  
	mode (arr) {
		var numMapping = {};
		var greatestFreq = 0;
		var mode;
		arr.filter(item => item != "").forEach(function findMode(item) {
			numMapping[item] = (numMapping[item] || 0) + 1;
    
			if (greatestFreq < numMapping[item]) {
				greatestFreq = numMapping[item];
				mode = item;
			}
		});
		return mode;
	}
}

let data = new Data();
	
export { data };
